import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "crd_sport_token";
const USER_KEY = "crd_sport_user";
const SUPPORT_SESSION_KEY = "matchium_support_session";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const support = getSupportSession();
  const url = String(config.url || "");
  const tournamentPrefix = support?.tournament_id ? `/tournaments/${support.tournament_id}` : "";
  if (support?.id && tournamentPrefix && (url === tournamentPrefix || url.startsWith(`${tournamentPrefix}/`))) {
    config.headers["X-Matchium-Support-Session"] = support.id;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      // Both authenticated shells need the login redirect: the organizer app
      // (/app/…) and the admin console (/admin/…).
      if (window.location.pathname.startsWith("/app") || window.location.pathname.startsWith("/admin")) {
        window.location.href = "/login";
      }
    }
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && typeof detail === "string" && detail.startsWith("support_")) {
      clearSupportSession();
      if (window.location.pathname.startsWith("/app/tournaments/")) {
        window.location.href = "/admin";
      }
    }
    return Promise.reject(err);
  }
);

export const getSupportSession = () => {
  try {
    const raw = sessionStorage.getItem(SUPPORT_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveSupportSession = (session) => {
  sessionStorage.setItem(SUPPORT_SESSION_KEY, JSON.stringify(session));
  window.dispatchEvent(new Event("matchium-support-change"));
};

export const clearSupportSession = () => {
  sessionStorage.removeItem(SUPPORT_SESSION_KEY);
  window.dispatchEvent(new Event("matchium-support-change"));
};

export const saveAuth = (token, user) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getStoredUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

